import {gql, useQuery} from "@apollo/client";
import React, {createContext, Dispatch, useContext, useEffect, useReducer} from "react";

const PROVIDER_EVENT_UNREAD_LAST_MONTH = gql`
{
    notificationUnreadInLastMonth
}
`;
export type ProviderEventUnreadAction =
    | { type: 'SET_LOADING_COMPLETE', loading: boolean, num: number }
    | { type: 'SET_REFRESH' }
    | { type: 'DECREASE', num: number }
    | { type: 'INCREASE', num: number }

export type NotificationState = {
    notificationsCount: number;
    shouldRefresh: boolean;
    loading: boolean;
}

function initState(): NotificationState {
    return {
        loading: true,
        shouldRefresh: false,
        notificationsCount: 0
    }
}

export const ProviderEventUnreadStateContext = createContext<NotificationState>(initState());

export const useProviderEventUnreadState = () => useContext(ProviderEventUnreadStateContext);

// @ts-ignore
export const ProviderEventUnreadDispatchContext = createContext<Dispatch<ProviderEventUnreadAction>>(null);

export const useProviderEventUnreadDispatch = () => useContext(ProviderEventUnreadDispatchContext);


function providerEventUnreadReducer(state: NotificationState, action: ProviderEventUnreadAction): NotificationState {
    switch (action.type) {
        case "DECREASE":
            let newCount = state.notificationsCount - action.num
            if (action.num > state.notificationsCount) {
                newCount = 0
            }
            return {
                ...state,
                notificationsCount: newCount
            };
        case "INCREASE":
            return {
                ...state,
                notificationsCount: state.notificationsCount + action.num
            };
        case "SET_LOADING_COMPLETE":
            return {
                ...state,
                notificationsCount: action.num,
                shouldRefresh: false,
                loading: action.loading
            };
        case "SET_REFRESH":
            return {
                ...state,
                loading: true,
                shouldRefresh: true
            };
    }
}

export const ProviderEventUnreadCount: React.FC = ({children}) => {
    const [state, dispatch] = useReducer(providerEventUnreadReducer, initState())
    const {data, refetch, error} = useQuery<{ notificationUnreadInLastMonth: number }, {}>(
        PROVIDER_EVENT_UNREAD_LAST_MONTH,
        {
            notifyOnNetworkStatusChange: true,
            onError: () => {
                console.log("ERROR HAPPENED: ", error)
                dispatch({
                    type: "SET_LOADING_COMPLETE", num: 0, loading: false
                })
            },
            onCompleted: () => {
                dispatch({
                    type: "SET_LOADING_COMPLETE",
                    num: data?.notificationUnreadInLastMonth ?? 0,
                    loading: false,
                })
            }
        }
    );
    useEffect(() => {
        if (state.shouldRefresh) {
            refetch().catch((err) => console.log("failed to refetch notification count by error: ", err));
        }
    }, [refetch, state.shouldRefresh])

    return (
        <ProviderEventUnreadStateContext.Provider value={state}>
            <ProviderEventUnreadDispatchContext.Provider value={dispatch}>
                {children}
            </ProviderEventUnreadDispatchContext.Provider>
        </ProviderEventUnreadStateContext.Provider>
    );
}